export function makeLoadHomeDataUseCase({ proposalsRepo, castingCallsRepo }) {
  return async function loadHomeData() {
    const [proposals, castingCalls] = await Promise.all([
      proposalsRepo.getFavoriteProposals(),
      castingCallsRepo.getCastingCalls(8),
    ]);

    return { proposals, castingCalls };
  };
}
